import { render, staticRenderFns } from "./MpBridge.vue?vue&type=template&id=f5936240&scoped=true&"
import script from "./MpBridge.vue?vue&type=script&lang=js&"
export * from "./MpBridge.vue?vue&type=script&lang=js&"
import style0 from "./MpBridge.vue?vue&type=style&index=0&id=f5936240&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5936240",
  null
  
)

export default component.exports